import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PlanoContaMatrizEditarRoutingModule } from "./plano-contas-matriz-editar-routing.module";
import { PlanoContaMatrizEditarComponent } from "./plano-contas-matriz-editar.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { HttpClientModule } from "@angular/common/http";
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import { InputSwitchModule } from "primeng/inputswitch";
import { ProgressSpinnerModule } from "primeng/progressspinner";


@NgModule({
    imports: [
        CommonModule,            
        HttpClientModule,        
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DividerModule,
        DropdownModule,
        FormsModule,
        InputTextareaModule,
        PlanoContaMatrizEditarRoutingModule,
        InputMaskModule,
        MessagesModule,
        InputSwitchModule,
        ProgressSpinnerModule
    ],
    declarations: [PlanoContaMatrizEditarComponent]
})
export class PlanoContaMatrizEditarModule { }
